import uniqueId from "lodash/uniqueId";
class FakeFilestackExtensionServie {
    getAttachmentUrl(attrs) {
        return `https://picsum.photos/500/500`;
    }
    getImageUrl(attrs) {
        return `https://picsum.photos/${attrs.size.width}`;
    }
    getVideoUrl(attrs) {
        return "";
    }
    validateUploadingFile(file) {
        if (file.size > 1 * 1024 * 1024) {
            window.alert("Maximum size is 1MB");
            return false;
        }
        return true;
    }
    async uploadByUrl(url) {
        return await Promise.resolve(null);
    }
    async uploadFile(file) {
        return await new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    handle: uniqueId(),
                    metadata: {
                        filename: file.name,
                        size: file.size,
                        container: "",
                        key: file.name,
                        mimetype: file.type,
                    },
                });
            }, 2000);
        });
    }
    async openPicker(mode) {
        return await Promise.resolve([]);
    }
    openModalGallery(view, attrs) { }
}
export const fakeFilestackExtensionService = new FakeFilestackExtensionServie();
